import { useSelector } from 'react-redux';
import { localization } from '../../utils/localization';

/**
 * Need the user's locale code or the corresponding map of translated strings? This hook will return both.
 * @returns {object} locale and translation
 */
export const useLocalization = () => {
  const registration = useSelector((state: { registration: any }) => state.registration);
  return localization(registration.language);
};
